import { useState } from 'react';
import { useInterval } from './useInterval';

export const useCountdown = (endTime: Date, interval = 1_000) => {
  const [count, setCount] = useState<number>(0);

  function onTick() {
    const newTime = new Date();

    if (newTime > endTime) {
      setCount(0);
      return;
    }
    const restTime = endTime.getTime() - newTime.getTime();
    const newCount = restTime > 0 ? Math.ceil(restTime / interval) : 0;

    setCount(newCount);
  }

  const { timerId } = useInterval(onTick, {
    interval,
    startImmediate: true,
    when: endTime > new Date(),
    endTime,
  });

  return { count, timer: timerId };
};
